import {api} from "./AxiosInstance";

export const GetDropDownApi = async (type='') => api.get(`/employee-connect/drop-downs?field=${type}`);

export const GetSingleEmployeeData = async (id) => api.get(`/employee-connect/employee/admin/${id}`);
